import translation_en from './en.json';
import translation_zh from './zh.json';

const resources = {
  en: {
    translation: translation_en,
  },
  zh: {
    translation: translation_zh,
  },
};

export default resources;